import React from 'react';

const Publications = () => {
    return (
        <div>
            This section is currently under construction.
            <br />
            <br />
            Scholarly output added here will be displayed in 'Other Scholarly Works' tab in 'My Profile' page.
        </div>
    );
};

export default Publications;